import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'AI Solutions',
      links: [
        { name: 'Lead Generation AI', href: '/services/lead-generation' },
        { name: 'Listing Automation', href: '/services/listing-automation' },
        { name: 'Market Analytics', href: '/services/market-analytics' },
        { name: 'Client Management', href: '/services/client-management' },
        { name: 'AI Staging', href: '/services/ai-staging' }
      ]
    },
    {
      title: 'Tools & Features',
      links: [
        { name: 'AI Chatbots', href: '/ai-tools/chatbots' },
        { name: 'Workflow Automation', href: '/ai-tools/automation' },
        { name: 'Social Media AI', href: '/ai-tools/social-media' },
        { name: 'Property Dashboard', href: '/dashboard' },
        { name: 'AI Clone Service', href: '/services/ai-clone' }
      ]
    },
    {
      title: 'Resources',
      links: [
        { name: 'Case Studies', href: '/resources/case-studies' },
        { name: 'Blog', href: '/blog' },
        { name: 'Documentation', href: '/resources/docs' },
        { name: 'Training', href: '/resources/training' },
        { name: 'Support Center', href: '/support' }
      ]
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', href: '/about' },
        { name: 'Careers', href: '/careers' },
        { name: 'Partners', href: '/partners' },
        { name: 'Privacy Policy', href: '/privacy' },
        { name: 'Terms of Service', href: '/terms' }
      ]
    }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <a href="/" className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <i className="ri-robot-2-fill text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-lg font-bold" style={{ fontFamily: 'Eurostile Extended, Microgramma D Extended, Arial Black, sans-serif', fontWeight: '900' }}>AI Realty Pro</h3>
                <p className="text-sm text-gray-400">Smart Real Estate Solutions</p>
              </div>
            </a>
            <p className="text-gray-400 text-sm mb-6">
              Empowering real estate professionals with cutting-edge AI technology for lead generation, automation, and market insights.
            </p>
            
            {/* Business Address */}
            <div className="mb-6">
              <h4 className="text-white font-semibold mb-2">Corporate Headquarters</h4>
              <div className="text-gray-400 text-sm">
                <p>Business Development Authority Inc</p>
                <p>725 E Road 2 N Unit 1494</p>
                <p>Chino Valley, AZ 86323</p>
              </div>
            </div>
            
            <div className="flex space-x-4">
              <a href="#" className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
                <i className="ri-twitter-x-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
                <i className="ri-youtube-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Footer Links */}
          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="font-semibold text-white mb-4">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} AIConsultingauthority.net. All rights reserved.
            </div>
            <div className="flex items-center space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </Link>
              <a 
                href="https://readdy.ai/?origin=logo" 
                className="text-gray-400 hover:text-white text-sm transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
